<template>
  <div class="wrapper">
    <dt class="label">
      <slot />
    </dt>
    <dd v-if="empty" class="value">
      <i>
        Leer
      </i>
    </dd>
    <dd v-else="empty" class="value">
      <article v-html="value" />
    </dd>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({value: String});
const empty = computed(() => !! props.value === false);
</script>

<style scoped>
.wrapper
{
  @apply py-4 sm:py-5 sm:px-6;
  @apply sm:grid sm:grid-cols-4 sm:gap-4;
}

.label
{
  @apply text-sm font-medium text-gray-500;
}

.value
{
  @apply mt-1 sm:mt-0 sm:col-span-3;
  @apply text-sm text-gray-900;
}
</style>
